<template>
  <div
    ref="blockRef"
    v-editable="blok"
    class="HotSpotBlock layout-container"
    :class="[desktopWidth('full'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div v-if="hotSpotContent[0]">
      <!--- **** Layout Default **** --->
      <div v-if="blok.layout === 'default'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
          <div class="AspectPortrait aspect-portrait">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-2 flex flex-col gap-8">
          <div class="AspectSquare aspect-square">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
        </div>
      </div>

      <!--- **** Layout Reversed **** --->
      <div v-if="blok.layout === 'reversed'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-2 flex flex-col gap-8">
          <div class="AspectSquare aspect-square">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
          <div class="AspectPortrait aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
        </div>
      </div>

      <!--- **** Layout Four Columns **** --->
      <div v-if="blok.layout === 'four-columns'" class="grid grid-cols-2 desk:grid-cols-4 gap-8">
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[0]">
              <HotSpotImage
                v-if="hotSpotContent[0]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[0]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[0]"
              />
            </div>
          </div>
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[1]">
              <HotSpotImage
                v-if="hotSpotContent[1]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[1]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[1]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[2]">
              <HotSpotImage
                v-if="hotSpotContent[2]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[2]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[2]"
              />
            </div>
          </div>
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[3]">
              <HotSpotImage
                v-if="hotSpotContent[3]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[3]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[3]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectLandscape relative aspect-landscape">
            <div v-if="hotSpotContent[4]">
              <HotSpotImage
                v-if="hotSpotContent[4]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[4]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[4]"
              />
            </div>
          </div>
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[5]">
              <HotSpotImage
                v-if="hotSpotContent[5]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[5]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[5]"
              />
            </div>
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-8">
          <div class="AspectPortrait relative aspect-portrait">
            <div v-if="hotSpotContent[6]">
              <HotSpotImage
                v-if="hotSpotContent[6]?.component === 'HotSpotImage'"
                :blok="hotSpotContent[6]"
                :products="products"
              />
              <HotSpotText
                v-else
                :blok="hotSpotContent[6]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex items-center justify-center p-24">
      Add Hot Spot Content
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import useVisualAppearancePlugin from '~/composeables/useVisualAppearancePlugin';
import HotSpotText from '~/components/hotspot/HotSpotText.vue';
import HotSpotImage from '~/components/hotspot/HotSpotImage.vue';
import useAlgoliaFetch from '~/composeables/useAlgoliaFetch';
import { ProductModel } from '~/models/product';
import useStoryblokAdmin from '~/composeables/useStoryblokAdmin';

type HotSpotBlockType = {
  _uid: string;
  title: string;
  hotSpotContent?: any[];
  layout: 'default' | 'reversed' | 'four-columns';
}

const props = defineProps<{ blok: HotSpotBlockType }>();
const hotSpotContent = computed(() => props.blok.hotSpotContent || []);
const { getExactVariantByPartNo, convertRawToProducts } = useAlgoliaFetch();
const { isInStoryblokAdmin } = useStoryblokAdmin();
const blockRef = ref<HTMLElement | null>(null);
const products = ref<ProductModel[]>([]);
const hasLoaded = ref(false);
const isLoading = ref(false);
let observer: IntersectionObserver | null = null;
let loadPromise: Promise<void> | null = null;

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

const productsPartNo = computed(() => {
  const partNos = hotSpotContent.value
    .filter((content) => content?.component === 'HotSpotImage')
    .flatMap((content) => content.hotSpots || [])
    .flatMap((hotSpot) => hotSpot.product || [])
    .filter((prodSelector) => prodSelector.product !== '')
    .map((prodSelector) => prodSelector.product?.product?.partNo)
    .filter((partNo): partNo is string => Boolean(partNo));
  return Array.from(new Set(partNos)).sort();
});

const loadProducts = async() => {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  if (productsPartNo.value.length) {
    const res = await getExactVariantByPartNo(productsPartNo.value);
    if (res) {
      const splitProducts = convertRawToProducts(res.hits, productsPartNo.value, [], true);
      products.value = splitProducts.map((m) => m.product);
    } else {
      console.log('@todo handle error');
    }
  } else {
    products.value = [];
  }
  isLoading.value = false;
  hasLoaded.value = true;
};

const loadProductsOnView = async() => {
  if (hasLoaded.value) {
    return;
  }
  if (loadPromise) {
    await loadPromise;
    return;
  }
  loadPromise = (async() => {
    await loadProducts();
  })();
  await loadPromise;
};

onMounted(async() => {
  if (!('IntersectionObserver' in window)) {
    await loadProductsOnView();
    return;
  }

  observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      loadProductsOnView();
      observer?.disconnect();
      observer = null;
    }
  }, {
    root: null,
    threshold: 0.1,
  });

  await nextTick();
  if (blockRef.value) {
    observer.observe(blockRef.value);
  }
});

onBeforeUnmount(() => {
  observer?.disconnect();
  observer = null;
});

if (isInStoryblokAdmin()) {
  watch(productsPartNo, async() => {
    if (hasLoaded.value) {
      await loadProducts();
    }
  });
}

/**
 * For now we skip json ld for hotspot block since products are loaded only in client
 * There is a fix to this in other project, probably iveo-storefront main or Kährs we can copy
 */
// const { buildItemListJsonLd } = useStructuredData();
// useJsonld(() => buildItemListJsonLd(products.value, 'HotSpotBlock'));
</script>

<style scoped lang="postcss">
:deep(.AspectLandscape .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-landscape;
}
:deep(.AspectPortrait .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-portrait;
}
:deep(.AspectSquare .HotSpotImageWrap, .HotSpotTextWrap) {
  @apply aspect-square;
}
</style>
